<template>
  <span @click="copy" :class="textClass" class="inline-flex gap-1">
    <span ref="text" :class="class">
      <slot />
    </span>
    <span>
      <i class="fa-solid fa-copy text-xs"></i>
    </span>
  </span>
</template>


<script>

export default {
  name: "CopySpan",
  data() {
    return {
      textClass: ''
    }
  },
  props: {
    class: {
      type: [String, Array, Object],
      default: "",
    }
  },
  methods: {
    copy() {
      this.textClass = 'copy';
      setTimeout(() => this.textClass = '', 400);

      const selecao = window.getSelection();
      const faixa = document.createRange();
      faixa.selectNodeContents(this.$refs.text);
      selecao.removeAllRanges();
      selecao.addRange(faixa);
      document.execCommand('copy');
      selecao.removeAllRanges();
      
    },
  },
};

</script>

<style scoped>

  .copy {
    animation: copy-animation .4s linear;
  }

  @keyframes copy-animation {
    0%, 100% {
      transform: scale(1);
    }
    10% {
      transform: scale(0.95);
    }
    50%, 75% {
      transform: scale(1.05);
    }
  }

</style>